/*jshint esversion: 9 */
import React from "react";
import { Fragment } from "react";
import { connect } from "react-redux";
// import { withStyles } from "@material-ui/core/styles";
import {
  doLog,
  getMMDDYYYY,
  getMMDDYYYYTime,
  getYYYYMMDD,
  hasValue,
} from "../../shared/utility";

import * as actions from "../../store/actions/index";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import classes from "../CrimeSubmission.css";
import { DataGrid } from "@mui/x-data-grid";
import { DEFAULT_GRID_OPTIONS } from "@material-ui/x-grid";
import Form from "../../components/UI/Form/Form";
import Grid from "@material-ui/core/Grid";
import LandingPage from "../../components/Navigation/LandingPage/LandingPage";
import moment from "moment";
import ReviewDetail from "./ReviewDetail";
import Select from "react-select";

// const styles = (theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//   },
//   textField: {
//     width: 250,
//   },
//   dense: {
//     marginTop: 19,
//   },
//   spacing: 1,
//   table: { "& .MuiTableCell-head": { fontWeight: 700 } },
// });

const gridSpacing = 0; //0 or 8 or 16 or 24 or 32 or 40
const quote = '"';
const singleQuote = "'";
const { rowHeight, headerHeight } = DEFAULT_GRID_OPTIONS;
let mappedSelectPropFields = [];
let mappedTextPropFields = ["paramStartDate", "paramEndDate"];

class Review extends Form {
  state = {
    searching: false,
    reportRunning: false,
    editMode: true,
    action: "",
    actionOption: null,
    //
    agencyOption: null,
    agencyEdit: false,
    agencyAdd: false,
    agencyORI: "",
    agencyCode: null,
    agencyCounty: "",
    agencyCityTwp: "",
    //
    includeProcessed: false,
    //
    mappedSelectPropFields: mappedSelectPropFields,
    mappedTextPropFields: mappedTextPropFields,
    //
    paramStartDate: {
      inputType: "datepicker",
      value: null,
      label: "From Date",
      disableFuture: true,
    },
    paramEndDate: {
      inputType: "datepicker",
      value: moment().format("MM/DD/YYYY"),
      label: "To Date",
      disableFuture: true,
    },
  };

  componentDidMount() {
    if (doLog()) console.log("[Review] componentDidMount state:", this.state);
    if (doLog()) console.log("[Review] componentDidMount props:", this.props);
    if (this.props.isAuthenticated) {
      if (this.props.webAgencyList === null) {
        const transactionType =
          '<CIDDB><QUERY TABLE="CitizenWebAgency" LIMIT="9999" OPERATORID="-1"><FIELD_LIST>ALL</FIELD_LIST></QUERY></CIDDB>';
        const data = {};
        const request = {
          transactionType,
          data,
        };
        this.setState({ searching: true });
        this.props.onRunTransaction(request, this.props.token, "webAgencyList");
      }
    } else if (
      hasValue(this.state.agencyORI) &&
      (!hasValue(this.props.result) ||
        !hasValue(this.props.result.RESULT) ||
        !hasValue(this.props.result.RESULT.CITIZENINCIDENT)) &&
      this.props.transDesc !== "incidentList"
    ) {
      if (!this.state.searching) {
        const transactionType =
          '<CIDDB><QUERY TABLE="CitizenIncident"' +
          ' WHERE="ORI=' +
          singleQuote +
          this.props.ori +
          singleQuote +
          " AND (STATUS = NULL OR STATUS = '')" +
          quote +
          ' LIMIT="9999" OPERATORID="-1"><FIELD_LIST>ALL</FIELD_LIST><ORDER_BY><INCIDENTDATETIME/></ORDER_BY></QUERY></CIDDB>';
        const data = {};
        const request = {
          transactionType,
          data,
        };
        this.setState({ searching: true });
        this.props.onRunTransaction(request, this.props.token, "incidentList");
      }
    }
    this.checkForSpecificAgency();
  }

  componentDidUpdate() {
    if (doLog()) console.log("[Review] componentDidUpdate state:", this.state);
    if (doLog()) console.log("[Review] componentDidUpdate props:", this.props);
    if (
      this.state.searching &&
      this.props.error === null &&
      ((this.props.transDesc === "webAgencyList" &&
        hasValue(this.props.webAgencyList)) ||
        hasValue(this.props.result))
    ) {
      if (doLog())
        console.log("[Review] componentDidUpdate result:", this.props.result);
      if (doLog())
        console.log(
          "[Review] componentDidUpdate transDesc:",
          this.props.transDesc
        );
      this.setState({ searching: false });
    } else if (
      hasValue(this.state.agencyORI) &&
      (!hasValue(this.props.result) ||
        !hasValue(this.props.result.RESULT) ||
        !hasValue(this.props.result.RESULT.CITIZENINCIDENT)) &&
      this.props.transDesc !== "incidentList"
    ) {
      if (!this.state.searching) {
        let statusOption =
          " AND (CITIZENINCIDENT.STATUS IS NULL OR CITIZENINCIDENT.STATUS = '' OR CITIZENINCIDENT.STATUS = 'response')";
        if (this.state.includeProcessed) {
          statusOption = "";
        }
        let dateOption = "";
        const fromDate = this.state.paramStartDate.value;
        const endDate = this.state.paramEndDate.value;
        if (doLog())
          console.log("[Review] componentDidUpdate fromDate:", fromDate);
        if (doLog())
          console.log("[Review] componentDidUpdate endDate:", endDate);
        if (hasValue(fromDate) && fromDate.length > 0)
          dateOption +=
            " AND (IncidentDateTime >= '" +
            getYYYYMMDD(fromDate) +
            " 00:00:00')";
        if (hasValue(endDate) && endDate.length > 0)
          dateOption +=
            " AND (IncidentDateTime <= '" +
            getYYYYMMDD(endDate) +
            " 23:59:59')";
        const transactionType =
          '<CIDDB><QUERY TABLE="CitizenIncident"' +
          ' WHERE="CITIZENINCIDENT.ORI=' +
          singleQuote +
          this.state.agencyORI +
          singleQuote +
          dateOption +
          statusOption +
          quote +
          ' LIMIT="9999" OPERATORID="-1"><FIELD_LIST>ALL</FIELD_LIST><ORDER_BY><INCIDENTNUMBER/></ORDER_BY>' +
          '<JOIN TABLE="CitizenIncidentType" OUTER="TRUE">' +
          "<FIELD_LIST><DESCRIPTION/></FIELD_LIST>" +
          '<ON><ORI SEARCH_TYPE="equal_to"><PARENT_FIELD>ORI</PARENT_FIELD></ORI></ON>' +
          '<ON><IncidentType SEARCH_TYPE="equal_to"><PARENT_FIELD>IncidentType</PARENT_FIELD></IncidentType></ON>' +
          "</JOIN>" +
          "</QUERY></CIDDB>";
        if (doLog())
          console.log(
            "[Review] componentDidUpdate transactionType:",
            transactionType
          );
        const data = {};
        const request = {
          transactionType,
          data,
        };
        this.setState({ searching: true });
        this.props.onRunTransaction(request, this.props.token, "incidentList");
      }
    }
    this.checkForSpecificAgency();
  }

  checkForSpecificAgency() {
    if (
      hasValue(this.props.webAgencyList) &&
      !hasValue(this.state.agencyOption) &&
      this.props.modulePermissions &&
      this.props.modulePermissions.allowedAgencyCode !== "ALL"
    ) {
      let index = this.props.webAgencyList.findIndex((element) => {
        return (
          element.AGENCYCODE ===
          this.props.modulePermissions.allowedAgencyCode.toUpperCase()
        );
      });
      if (doLog()) console.log("[Review] checkForSpecificAgency index:", index);
      const row = this.props.webAgencyList[index];
      if (doLog()) console.log("[Review] checkForSpecificAgency row:", row);
      if (hasValue(row)) {
        const selectedAgency = {
          value: index,
          label: row.NAME,
        };
        this.setState({
          agencyOption: selectedAgency,
          agencyDisabled: true,
          agencyORI: row.ORI,
          agencyCode: this.props.modulePermissions.allowedAgencyCode,
          agencyCounty: row.COUNTY,
          agencyCityTwp: row.CITY_TOWNSHIP,
        });
      }
    }
  }

  handleAgencyChange = (agencySelected) => {
    if (agencySelected.value === -1) {
      this.setState({
        agencyOption: null,
        agencyEdit: false,
        agencyAdd: true,
        agencyORI: "",
        agencyCode: null,
        agencyCounty: "",
        agencyCityTwp: "",
        action: "",
        actionOption: null,
      });
    } else {
      this.setState({
        agencyOption: agencySelected,
        agencyEdit: false,
        agencyAdd: false,
        agencyORI: this.props.webAgencyList[agencySelected.value].ORI,
        agencyCode: this.props.webAgencyList[agencySelected.value].AGENCYCODE,
        agencyCounty: this.props.webAgencyList[agencySelected.value].COUNTY,
        agencyCityTwp: this.props.webAgencyList[agencySelected.value]
          .CITY_TOWNSHIP,
        action: "",
        actionOption: null,
      });
    }
    if (doLog())
      console.log(
        `[Review] handleAgencyChange optionSelected:`,
        agencySelected
      );
    this.props.onClearTransactionResult();
    this.props.onClearTransDesc();
  };

  handleDetailCancel() {
    if (doLog()) console.log("[Review] handleAgencyCancel");
    this.setState({ item: null });
  }

  handleFilterCheckBox = () => (event) => {
    this.setState({ includeProcessed: event.target.checked });
    this.props.onClearTransactionResult();
    this.props.onClearTransDesc();
  };

  handleRefreshButton = () => {
    if (doLog()) console.log("[Review] handleRefreshButton");
    this.props.onClearTransactionResult();
    this.props.onClearTransDesc();
  };

  handleRowClick = (param, event) => {
    if (doLog()) console.log("[Review] handleRowClick param:", param);
    if (doLog()) console.log("[Review] handleRowClick event:", event);
    if (param != null && param.row != null) {
      const array = this.props.result.RESULT.CITIZENINCIDENT;
      const row = param.row;
      let item = null;
      if (hasValue(array.length)) item = array[row.id];
      else item = array;
      if (doLog()) console.log("[Review] handleRowClick item:", item);
      this.setState({
        item: item,
        itemChanged: true,
        actionEdit: true,
        actionAdd: false,
      });
    }
  };

  render() {
    if (doLog()) console.log("[Review] render props:", this.props);
    //-----------------------------------------------------------
    let agencySection = null;
    let filterSection = null;
    let refreshSection = null;
    let agencyOptions = [];
    let agencySelect = null;
    if (this.props.webAgencyList !== null) {
      for (let i = 0; i < this.props.webAgencyList.length; i++) {
        const fields = this.props.webAgencyList[i];
        if (fields.AGENCYCODE !== "DEFAULTDATA") {
          agencyOptions.push({ value: i, label: fields.NAME });
        }
      }
      if (doLog())
        console.log(
          "[Review] render webAgencyList length:",
          this.props.webAgencyList.length
        );
      if (doLog()) console.log("[Review] render agencyOptions:", agencyOptions);

      if (
        hasValue(this.state.agencyOption) ||
        (hasValue(this.state.agencyDisabled) &&
          this.state.agencyDisabled === true)
      ) {
        refreshSection = (
          <Fragment>
            <Button
              variant="contained"
              //color="default"
              color="primary"
              size="small"
              onClick={this.handleRefreshButton.bind(this)}
            >
              Refresh
            </Button>
          </Fragment>
        );

        filterSection = (
          <Fragment>
            <Grid item xs={3}>
              <p>From Date:</p>
            </Grid>
            <Grid item xs={3}>
              <p>To Date:</p>
            </Grid>
            <Grid item xs={3}>
              <Checkbox
                checked={this.state.includeProcessed}
                onChange={this.handleFilterCheckBox()}
                color="default"
              />
              Include processed incidents
            </Grid>
            <Grid item xs={3} />
            <Grid item xs={3}>
              {this.getFormField("paramStartDate", false, false)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("paramEndDate", false, false)}
            </Grid>
            <Grid item xs={3}>
              {refreshSection}
            </Grid>
            <Grid item xs={3} />
            <Grid item xs={12}>
              &nbsp;
            </Grid>
          </Fragment>
        );
      }

      agencySelect = (
        <Grid container item>
          <Grid item xs={12}>
            <Select
              value={this.state.agencyOption}
              onChange={this.handleAgencyChange}
              options={agencyOptions}
              isSearchable="true"
              isDisabled={this.state.agencyDisabled}
            />
          </Grid>
          {filterSection}
        </Grid>
      );

      if (
        hasValue(this.state.agencyDisabled) &&
        this.state.agencyDisabled === true
      ) {
        agencySection = (
          <Grid container item>
            <Grid item xs={12}>
              <p>Agency: {this.state.agencyOption.label}</p>
            </Grid>
            <Grid item xs={12}>
              {filterSection}
            </Grid>
          </Grid>
        );
      } else {
        agencySection = (
          <Fragment>
            <p>Select an Agency:</p>
            {agencySelect}
          </Fragment>
        );
      }
    }

    let activeSection = null;
    let listRows = [];
    if (
      hasValue(this.state.agencyORI) &&
      !this.state.searching &&
      hasValue(this.props.result !== null) &&
      hasValue(this.props.result.RESULT) &&
      hasValue(this.props.result.RESULT.CITIZENINCIDENT)
    ) {
      const array = this.props.result.RESULT.CITIZENINCIDENT;
      if (doLog()) console.log("[Review] render array:", array);
      if (doLog()) console.log("[Review] render array length:", array.length);
      if (array !== null) {
        if (hasValue(array.length)) {
          for (let i = 0; i < array.length; i++) {
            const fields = array[i];
            let status = "Received";
            if (fields.STATUS === "acceptI") status = "Sent To RMS";
            else if (fields.STATUS === "reject") status = "NOT Sent To RMS";
            else if (fields.STATUS === "reqinfo") status = "More Info Needed";
            else if (fields.STATUS === "reqmade")
              status = "More Info Was Requested";
            else if (fields.STATUS === "response") {
              const date = getMMDDYYYY(fields.LASTUSERUPDATED);
              status = "Requested Info Received: " + date;
            }
            listRows.push({
              id: i,
              incidentNumber: fields.INCIDENTNUMBER,
              typeCode: fields.ViaDataItems.CITIZENINCIDENTTYPE.DESCRIPTION,
              incidentDateTime: getMMDDYYYYTime(fields.INCIDENTDATETIME),
              status: status,
            });
          }
        } else {
          const fields = array;
          let status = "Received";
          if (fields.STATUS === "acceptI") status = "Sent to RMS";
          else if (fields.STATUS === "reject") status = "NOT Sent To RMS";
          else if (fields.STATUS === "reqinfo") status = "More Info Needed";
          else if (fields.STATUS === "reqmade")
            status = "More Info Was Requested";
          else if (fields.STATUS === "response") {
            const date = getMMDDYYYY(fields.LASTUSERUPDATED);
            status = "Requested Info Was Received: " + date;
          }

          listRows.push({
            id: 0,
            incidentNumber: fields.INCIDENTNUMBER,
            typeCode: fields.ViaDataItems.CITIZENINCIDENTTYPE.DESCRIPTION,
            incidentDateTime: getMMDDYYYYTime(fields.INCIDENTDATETIME),
            status: status,
          });
        }
      }
    }
    const listColumns = [
      {
        field: "incidentNumber",
        renderHeader: (params) => <strong>{"Tracking #"}</strong>,
        width: 120,
      },
      {
        field: "typeCode",
        renderHeader: (params) => <strong>{"Incident Type"}</strong>,
        width: 300,
      },
      {
        field: "incidentDateTime",
        renderHeader: (params) => <strong>{"Received Date/Time"}</strong>,
        width: 190,
      },
      {
        field: "status",
        renderHeader: (params) => <strong>{"Status"}</strong>,
        width: 300,
      },
    ];

    const optionSelect = (
      <Fragment>
        <Grid item xs={12}>
          <div style={{ height: headerHeight + rowHeight * 4 }}>
            <DataGrid
              rows={listRows}
              columns={listColumns}
              onRowClick={this.handleRowClick}
              getRowHeight={() => "auto"}
            />
          </div>
        </Grid>
      </Fragment>
    );

    if (hasValue(this.state.agencyORI)) {
      activeSection = <Fragment>{optionSelect}</Fragment>;
    }
    //}

    let detailFormSection = null;
    if (hasValue(this.state.item)) {
      detailFormSection = (
        <ReviewDetail
          key={Math.random()}
          item={this.state.item}
          agencyCode={this.state.agencyCode}
          agencyCounty={this.state.agencyCounty}
          agencyCityTwp={this.state.agencyCityTwp}
          onCancel={this.handleDetailCancel.bind(this)}
        />
      );
    }

    let formHeader = (
      <Grid container item spacing={gridSpacing}>
        <Grid item xs={12} className={classes.FormHeader}>
          <p>Review</p>
        </Grid>
        {/* {errorMessage} */}
      </Grid>
    );

    let formFields = (
      <Grid container item spacing={gridSpacing} className={classes.LongerCard}>
        <Grid item xs={12} className={classes.FormFields}>
          <Grid container item>
            {agencySection}
            {activeSection}
            {detailFormSection}
          </Grid>
        </Grid>
      </Grid>
    );

    //-----------------------------------------------------------
    return (
      <Fragment>
        <LandingPage />
        <div className={classes.CrimeSubmission}>
          <Grid container item spacing={gridSpacing}>
            {formHeader}
            {formFields}
          </Grid>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  if (doLog()) console.log("[Review].mapStateToProps state:", state);
  return {
    loading: state.trans.loading,
    result: state.trans.result,
    transDesc: state.trans.transDesc,
    error: state.trans.error,
    authError: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    //
    agencyCode: state.trans.agencyCode,
    modulePermissions: state.auth.modulePermissions,
    webAgencyList: state.trans.webAgencyList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRunTransaction: (options, token, transDesc) =>
      dispatch(actions.runTransaction(options, token, transDesc)),
    onClearTransactionResult: () => dispatch(actions.clearTransactionResult()),
    onClearTransDesc: () => dispatch(actions.clearTransDesc()),
    onClearReportResult: () => dispatch(actions.clearReportResult()),
  };
};

// export default withStyles(styles)(
//   connect(mapStateToProps, mapDispatchToProps)(Review)
// );
export default connect(mapStateToProps, mapDispatchToProps)(Review);
